var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5769 10.3616H18C18 10.1372 17.9086 9.92168 17.7434 9.76273C17.414 9.4464 16.8873 9.44267 16.5526 9.75382L12.4998 13.5269L8.44708 9.75387C8.11288 9.44263 7.58595 9.44636 7.25627 9.76298C6.91074 10.0954 6.91526 10.6426 7.26594 10.9692L11.9097 15.2925C12.2403 15.5998 12.7594 15.5998 13.0902 15.2923L17.7335 10.9693C17.9046 10.8102 18 10.5906 18 10.3616H17.5769Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.8b51f7bb2420ed1070df42be10580ecd.svg";
export { ForwardRef as ReactComponent };